
<template>
  <div class="row about" id="pakiet-pszczelego-bohatera-mp">
    <div class="col-12 text-center">
      <div class="about__box" style="">
        <h2 class="about__headline" v-if="content.data.test_ab.active">
          <Ab
            @sample="(value) => (test_ab_content = value)"
            :weight="{ test_ab_contentA: 50, test_ab_contentB: 50 }"
          >
            <span
              slot="test_ab_contentA"
              v-html="content.data.test_ab.heropack_a_header"
            ></span>
            <span
              slot="test_ab_contentB"
              v-html="content.data.test_ab.heropack_b_header"
            ></span>
          </Ab>
        </h2>

        <h2
          v-else
          class="about__headline"
          v-html="content.data.hero_pack.header"
        ></h2>
        <div class="about__content">
          <img
            src="@/assets/images/12/pakiet.jpg"
            class="about__img mb-3"
            alt="Pakiet Pszczelego Bohatera"
          />
          <div v-html="content.data.hero_pack.content"></div>
        </div>
        <router-link
          v-if="content.data.hero_pack.btn.show"
          class="about__btn"
          :to="content.data.hero_pack.btn.link"
        >
          {{ content.data.hero_pack.btn.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Ab from "vue-ab";
export default {
  name: "BeeHeroPack",
  inject: ["content"],
  components: { Ab },
  data() {
    return {
      title: "PPB",
    };
  },
};
</script>
